import { render, staticRenderFns } from "./CheckOrdP.vue?vue&type=template&id=90b4152e&scoped=true"
import script from "./CheckOrdP.vue?vue&type=script&lang=js"
export * from "./CheckOrdP.vue?vue&type=script&lang=js"
import style0 from "./CheckOrdP.vue?vue&type=style&index=0&id=90b4152e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4152e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90b4152e')) {
      api.createRecord('90b4152e', component.options)
    } else {
      api.reload('90b4152e', component.options)
    }
    module.hot.accept("./CheckOrdP.vue?vue&type=template&id=90b4152e&scoped=true", function () {
      api.rerender('90b4152e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/CheckOrdP.vue"
export default component.exports